import { K as r, a as u } from "./keys-BE_UDsFf.js";
function i(n, e, a) {
  if (n === null)
    return 0;
  const t = n + e, c = a - 1, s = 0;
  return t < s ? c : t > c ? s : t;
}
function o(n) {
  return n === r.UP || n === r.LEFT ? -1 : n === r.DOWN || n === r.RIGHT ? 1 : 0;
}
function l(n, e = !1) {
  return n === u.TAB && e ? -1 : n === u.TAB ? 1 : 0;
}
export {
  o as a,
  i as b,
  l as c
};
